export function deepMerge(obj1: Record<string, any>, obj2: Record<string, any>) {
  const result = { ...obj1 }
  Object.keys(obj2).forEach((key) => {
    if (Object.hasOwn(obj2, key)) {
      if (typeof obj2[key] === 'object' && obj2[key] !== null) {
        if (Array.isArray(obj2[key])) {
          result[key] = Array.isArray(result[key]) ? [...result[key], ...obj2[key]] : [...obj2[key]]
        } else {
          result[key] = deepMerge(result[key] || {}, obj2[key])
        }
      } else {
        result[key] = obj2[key]
      }
    }
  })

  return result
}
